
import { CssColorType } from "@/common/customTypes";
import { Component, Prop, Vue } from "vue-property-decorator";
import { TopTipsTip, TopTipsTips } from "../top-tips/TopTips";

@Component
export default class TypeColorText extends Vue {
  @Prop({ type: String, default: "" }) readonly defaultColorType!: CssColorType;
  @Prop({ type: [Array, String], default: "" }) readonly texts!: TopTipsTips;

  get textsToShow(): TopTipsTip[] {
    return typeof this.texts === "string"
      ? [{ text: this.texts, colorType: "" }]
      : this.texts.map((text: string | TopTipsTip) => {
          return typeof text === "string" ? { text, colorType: "" } : text;
        });
  }
}
